import { subDays, format, getDaysInMonth } from 'date-fns'
import availableRoles from '@/helpers/availableRolesHelper'

export default function() {
    return {
        availableRoles: [
            {
                label: 'Todos',
                value: 'ROLE_CONTRACTOR,ROLE_PROFESSIONAL'
            },
            ...availableRoles
        ],
        profiles: [],
        fields: [
            {
                key: 'name',
                label: 'Nome'
            },
            {
                key: 'role',
                label: 'Tipo'
            },
            {
                key: 'createdAt',
                label: 'Data de cadastro'
            },
            {
                key: 'actions',
                label: 'Ações'
            }
        ],
        itemsPerPage: 15,
        totalPages: 0,
        currentPage: 1,
        'order[createdAt]': 'DESC',
        filters: {
            'month[after]': format(subDays(new Date().setDate(1), 180), 'yyyy-MM-dd'),
            'month[before]': format(new Date().setDate(getDaysInMonth(new Date())), 'yyyy-MM-dd'),
            'createdAt[after]': null,
            'createdAt[before]': null,
            roles: ['ROLE_CONTRACTOR', 'ROLE_PROFESSIONAL']
        },
        charts: {
            ROLE_CONTRACTOR: {
                months: {},
                total: 0,
                label: 'Contratantes',
                color: 'info'
            },
            ROLE_PROFESSIONAL: {
                months: {},
                total: 0,
                label: 'Prestadores',
                color: 'success'
            }
        }
    }
}
